module.exports = __webpack_public_path__ + "img/arrow-down-normal.3557d20e.png";